import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'GastronomyDetails',
    props: {
        restaurant: {}
    },
    setup(__props) {
        const props = __props;
        const restaurantName = computed(() => props.restaurant?.name || props.restaurant?.title || '');
        const restaurantDescription = computed(() => props.restaurant?.description || '');
        const restaurantType = computed(() => {
            const raw = props.restaurant?.cuisine_type || props.restaurant?.type || 'restaurante';
            const t = String(raw).trim();
            return t ? t.charAt(0).toUpperCase() + t.slice(1) : 'Restaurante';
        });
        const entityTypeLabel = computed(() => {
            const t = String(props.restaurant?.type || props.restaurant?.cuisine_type || 'restaurante').toLowerCase();
            const map = {
                restaurant: 'Restaurante',
                accommodation: 'Hotel',
                hotel: 'Hotel',
                event: 'Evento',
                museum: '',
                city: 'Ciudad',
                attraction: 'Atractivo',
                place: 'Lugar'
            };
            return map[t] || (t ? t.replace(/^./, (c) => c.toUpperCase()) : 'Lugar');
        });
        const restaurantPrice = computed(() => props.restaurant?.price_per_night || 'Consultar');
        const restaurantRating = computed(() => {
            const r = props.restaurant?.rating;
            return r ? `${r}/5 ⭐` : 'Sin rating';
        });
        const restaurantLocation = computed(() => props.restaurant?.location || 'No especificado');
        const restaurantAddress = computed(() => props.restaurant.address || 'Sin dirección');
        const restaurantHours = computed(() => props.restaurant?.place?.opening_hours || 'No disponible');
        const restaurantContact = computed(() => props.restaurant?.place?.contact_info || props.restaurant?.phone || 'No disponible');
        const restaurantWebsite = computed(() => props.restaurant?.website || props.restaurant?.link || null);
        const restaurantFacebook = computed(() => props.restaurant?.facebook || null);
        const restaurantInstagram = computed(() => props.restaurant?.instagram || null);
        const restaurantWhatsapp = computed(() => props.restaurant?.whatsapp || null);
        const hasSocialLinks = computed(() => !!(restaurantWebsite.value || restaurantFacebook.value || restaurantInstagram.value || restaurantWhatsapp.value));
        // Helpers
        const sanitizeDigits = (v) => (v || '').replace(/[^\d]/g, '');
        const formattedWhatsapp = computed(() => {
            const num = sanitizeDigits(restaurantWhatsapp.value);
            return num ? `https://wa.me/${num}` : null;
        });
        const formattedPhone = computed(() => {
            const num = sanitizeDigits(restaurantContact.value);
            return num ? `tel:${num}` : null;
        });
        return (_ctx, _cache) => {
            return null;
        };
    }
});
